import { Component } from "@angular/core";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import moment from "moment";
import { UserService } from "../../../../../auth/service";
import { StatsService } from "../../stats.service";
import { ApexAxisChartSeries } from "ng-apexcharts";
import { BarsChartOptions } from "../recruitment-stats/recruitment-stats.component";

interface CommercialUser {
  avatar: string;
  firstname: string;
  lastname: string;
  complete_name: string;
  hash: string;
  figure: string;
  working_city: string;
  badge_number: string;
  number: string;
}

interface CommercialStatistic {
  commercial_hash?: string;
  commercial_complete_name?: string;
  counter_request: number;
  counter_step_0: number;
  counter_step_1: number;
  counter_step_2_3: number;
  counter_step_4: number;
  counter_step_5: number;
  counter_step_6: number;
  counter_step_7: number;
}

@Component({
  selector: "app-commercial-stats",
  templateUrl: "./commercial-stats.component.html"
})

export default class CommercialStatsComponent {
  contentHeader: IContentHeader = {
    headerTitle: "MENU.COMMERCIAL_STATISTICS",
    breadcrumb: {
      links: [
        {
          name: "Home",
          isLink: true,
          link: "/"
        },
        {
          name: "MENU.RECRUITMENT",
          isLink: false
        },
        {
          name: "MENU.COMMERCIAL_STATISTICS",
          isLink: false
        }
      ]
    }
  };

  filterFrom: string = moment().startOf("year").format("YYYY-MM-DD");
  filterTo: string = moment().format("YYYY-MM-DD");
  filterCommercial: string = "";
  commercialUsers: CommercialUser[] = [];
  statistics: CommercialStatistic;
  loadedStats = false;

  barsChartOptions: BarsChartOptions = {
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      style: {
        colors: ["#fff"],
      },
      formatter: (val, opt) => `${opt.w.globals.labels[opt.dataPointIndex]}:  ${val}`,
      offsetX: 15,
      dropShadow: {
        enabled: true,
      },
    },
    tooltip: {
      theme: "dark",
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: () => "",
        },
      },
    },
  };
  chartSeries: ApexAxisChartSeries | undefined = undefined;

  constructor(private userService: UserService, private statsService: StatsService) {
    if (!window.location.search.includes("reloadForChart")) {
      const url: string = window.location.href + "?reloadForChart";
      window.history.replaceState({}, "", url);
      window.location.href = url;
    } else {
      this.loadStats();
      this.userService.getCommercialList()
        .then((response: any) => {
          this.commercialUsers = response as CommercialUser[];
        });
    }
  }

  loadStats() {
    this.statsService.getCommercialStats(this.filterFrom, this.filterTo).subscribe((response: any) => {
      if (this.filterCommercial.length > 1) {
        this.statistics = response.find((stat: CommercialStatistic) => stat.commercial_hash === this.filterCommercial);
        delete this.statistics.commercial_hash;
        delete this.statistics.commercial_complete_name;
      } else {
        this.statistics = {
          counter_request: response.map((stat: CommercialStatistic) => stat.counter_request).reduce((a, b) => a + b, 0) || 0,
          counter_step_0: response.map((stat: CommercialStatistic) => stat.counter_step_0).reduce((a, b) => a + b, 0) || 0,
          counter_step_1: response.map((stat: CommercialStatistic) => stat.counter_step_1).reduce((a, b) => a + b, 0) || 0,
          counter_step_2_3: response.map((stat: CommercialStatistic) => stat.counter_step_2_3).reduce((a, b) => a + b, 0) || 0,
          counter_step_4: response.map((stat: CommercialStatistic) => stat.counter_step_4).reduce((a, b) => a + b, 0) || 0,
          counter_step_5: response.map((stat: CommercialStatistic) => stat.counter_step_5).reduce((a, b) => a + b, 0) || 0,
          counter_step_6: response.map((stat: CommercialStatistic) => stat.counter_step_6).reduce((a, b) => a + b, 0) || 0,
          counter_step_7: response.map((stat: CommercialStatistic) => stat.counter_step_7).reduce((a, b) => a + b, 0) || 0
        }
      }
      this.loadedStats = true;
      this.chartSeries = [{ data: Object.values(this.statistics).slice(1) }];
    });
  }

}